import { render } from "./LiveTestReportNew.vue?vue&type=template&id=1fc4e629&scoped=true&ts=true"
import script from "./LiveTestReportNew.vue?vue&type=script&lang=ts"
export * from "./LiveTestReportNew.vue?vue&type=script&lang=ts"

import "./LiveTestReportNew.vue?vue&type=style&index=0&id=1fc4e629&scoped=true&lang=css"
import "./LiveTestReportNew.vue?vue&type=style&index=1&id=1fc4e629&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc4e629"]])

export default __exports__